import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=d2234798&scoped=true"
import script from "./EmptyState.vue?vue&type=script&lang=ts"
export * from "./EmptyState.vue?vue&type=script&lang=ts"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=d2234798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2234798",
  null
  
)

export default component.exports